import React, {Component} from 'react';
import {Row, Col, Card, Button, Input, InputGroup, InputGroupAddon} from 'reactstrap';
import {SubmissionError} from 'redux-form';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import LaddaButton, {EXPAND_LEFT} from 'react-ladda';
import 'ladda/dist/ladda-themeless.min.css';
import {Alert} from 'reactstrap';
import {toast} from "react-toastify";

const renderFieldLogin = ({name, input, label, type, meta: {touched, error}}) => {

    return (

        <InputGroup className="mb-3">
            <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="icon-user"></i>
                  </span>
            </div>
            <Input type="text" placeholder="Email"  {...input} />
        </InputGroup>

    )
};



class ForgotForm extends Component {


    constructor(props) {

        super(props);

    }
    redirect(){
        const {history} = this.props
        history.push('/login')
    }

    render() {

        const {error, handleSubmit, pristine, reset, submitting} = this.props;

        return (

            <form onSubmit={handleSubmit}>


                {error && <Alert color="danger">{error}</Alert>}

                <Field
                    name="email"
                    component={renderFieldLogin}
                    type="text"
                />

                <Row>
                    <Col xs="6">

                        <LaddaButton
                            className="btn btn-success btn-ladda"
                            loading={submitting}
                            data-style={EXPAND_LEFT}
                            type={'submit'}
                        >
                            Envoyer </LaddaButton>
                    </Col>
                    <Col xs="6" className="text-right">
                        <Button onClick={() => this.redirect()} color="link" className="px-0"> Se connecter?</Button>
                    </Col>
                </Row>
            </form>

        );
    }
}

ForgotForm = reduxForm({
    form: 'ForgotForm'
})(ForgotForm);


export default ForgotForm



// WEBPACK FOOTER //
// ./src/views/Pages/Login/ForgotForm.js